<script setup lang="ts">
interface Props {
  label?: string
  description?: string
  hint?: string
  help?: string
  error?: string | boolean
  required?: boolean
  name?: string
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

const props = withDefaults(defineProps<Props>(), {
  size: 'md'
})

const labelSizes = {
  xs: 'text-xs',
  sm: 'text-xs',
  md: 'text-sm',
  lg: 'text-sm',
  xl: 'text-base'
}
</script>

<template>
  <div class="space-y-1">
    <div v-if="label || $slots.label" class="flex items-center justify-between">
      <label
        :for="name"
        class="block font-medium text-gray-700"
        :class="labelSizes[size]"
      >
        <slot name="label">{{ label }}</slot>
        <span v-if="required" class="text-red-500 ml-0.5">*</span>
      </label>
      <span v-if="hint || $slots.hint" class="text-xs text-gray-500">
        <slot name="hint">{{ hint }}</slot>
      </span>
    </div>
    <p v-if="description || $slots.description" class="text-sm text-gray-500">
      <slot name="description">{{ description }}</slot>
    </p>
    <div>
      <slot />
    </div>
    <p v-if="error && typeof error === 'string'" class="text-sm text-red-500">
      {{ error }}
    </p>
    <p v-else-if="help || $slots.help" class="text-sm text-gray-500">
      <slot name="help">{{ help }}</slot>
    </p>
  </div>
</template>
